import {SVGProps} from "react";

// Support headset from the V2 footer (Figma "Icon / headset", 78:877).
export const HeadsetSvg = ({color = '#E4BD79', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path
            d="M3.66667 11.9167V10.0833C3.66667 8.13841 4.43928 6.27315 5.81455 4.89788C7.18982 3.52262 9.05508 2.75 11 2.75C12.9449 2.75 14.8102 3.52262 16.1855 4.89788C17.5607 6.27315 18.3333 8.13841 18.3333 10.0833V11.9167M18.3333 16.5V18.3333C18.3333 18.8196 18.1402 19.2859 17.7964 19.6297C17.4525 19.9735 16.9862 20.1667 16.5 20.1667H11.9167M3.66667 11H2.75V16.5H6.41667V11H3.66667ZM18.3333 11H19.25V16.5H15.5833V11H18.3333Z"
            stroke={color} strokeWidth="1.55833" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
